import React from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { Drawer as DrawerCreate, IconButton, Typography } from '@mui/material';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import CloseIcon from '@mui/icons-material/Close';

type DrawerHeaderProps = {
  title: string;
  onClose: () => void;
};

const DrawerHeader: React.FC<DrawerHeaderProps> = ({ title, onClose }) => (
  <div className="header">
    <Typography
      variant="h5"
      sx={{ fontWeight: '600' }}
    >
      {title}
    </Typography>
    <IconButton
      onClick={onClose}
      sx={{ color: '#000' }}
    >
      <CloseIcon />
    </IconButton>
  </div>
);

type DrawerBannerProps = {
  title?: string;
  children?: React.ReactNode;
};

export const DrawerBanner: React.FC<DrawerBannerProps> = ({ children, title = 'Новый баннер' }) => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);

  const handleCloseDrawer = () => {
    dispatch(setDrawerOpen(false));
  };

  return (
    <DrawerCreate
      anchor="right"
      open={isDrawerOpen}
      onClose={handleCloseDrawer}
    >
      <DrawerContent>
        <DrawerHeader
          title={title}
          onClose={handleCloseDrawer}
        />
        <div className="content">{children}</div>
      </DrawerContent>
    </DrawerCreate>
  );
};
